import { initContract } from '@ts-rest/core';
import { adminReferralContract } from './referral.admin.contract';
import { authReferralContract } from './referral.auth.contract';

const c = initContract();

export const referralContract = c.router(
  {
    auth: authReferralContract,
    admin: adminReferralContract,
  },
  {
    pathPrefix: '/referral',
    strictStatusCodes: true,
    jsonQuery: true,
  }
);

export * from './referral.admin.contract';
export * from './referral.auth.contract';
export * from './models';

